<template>
  <div id="quickview" class="quickview-wrapper quickview--signup" data-pages="quickview">
    <div class="view-heading">
      <a class="btn-link quickview-toggle"
         @click="resetForm()"
         data-toggle-element="#quickview"
         data-toggle="quickview"
         ref="quickviewButton">
        <i class="pg-close close-sidebar cursor-hand"></i>
      </a>
    </div>
    <div class="view-body p-2 sm-p-l-15 sm-p-r-15 sm-p-t-40">
      <transition name="slide-fade">
        <form @submit.prevent="submit" class="p-t-15" role="form" novalidate="novalidate" autocomplete="off">

          <transition name="slide-fade">
            <div v-if="hasErrors" class="alert alert-danger">
              <ul>
                <li v-for="(error, index) in serverErrors" :key="'error_' + index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </transition>

          <input-text v-model="user.email"
                      validationRules="required|email"
                      :validationTranslation="$t('models.user.email')"
                      fieldName="email"
                      fieldId="email"
                      fieldType="email"
                      :label="$t('models.user.email')"
                      :required="true"
                      :disabled="false" />

          <div v-if="mailCheckedEmail" class='form--notice form--suggestEmail'>
            {{ $t("models.user.error_email") }}<span @click="setEmail" class="email-suggestion">{{ mailCheckedEmail }}</span> ?
          </div>

          <div v-if="existingInAnotherEntity && !user.pending" class="existence-notice">
            {{ $t('UserForm.notice_blue') }}
          </div>

          <div v-if="existingInAnotherEntity && user.pending" class="existence-notice red">
            {{ $t('UserForm.candidate_confirm_requirement') }}
          </div>

          <div v-if="userExist && existenceInEntity && !userExistDifferentRole" class="existence-notice red">
            {{ showEntityName ? $t('UserForm.candidate_attached_to_entity') : $t('UserForm.notice_red') }}
          </div>

          <div v-if="userExist && userExistDifferentRole" class="existence-notice red">
            {{ $t('UserForm.email_taken') }}
          </div>

          <input-text v-model="user.last_name"
                      validationRules="required"
                      :validationTranslation="$t('models.user.last_name')"
                      fieldName="last_name"
                      fieldId="last_name"
                      fieldType="text"
                      :label="$t('models.user.last_name')"
                      :required="true"
                      :disabled="userExist && !userExistDifferentRole" />

          <input-text v-model="user.first_name"
                      validationRules="required"
                      :validationTranslation="$t('models.user.first_name')"
                      fieldName="first_name"
                      fieldId="first_name"
                      fieldType="text"
                      :label="$t('models.user.first_name')"
                      :required="true"
                      :disabled="userExist && !userExistDifferentRole" />

          <input-text v-model="user.phone_display"
                      validationRules="required|phone"
                      :validationTranslation="$t('models.user.phone')"
                      fieldName="phone"
                      fieldId="phone"
                      fieldType="text"
                      :label="$t('models.user.mobile_phone')"
                      :required="true"
                      :disabled="userExist && !userExistDifferentRole" />

          <div v-if="showUnavailabilityDatesProviderId">
            <input-text v-model="user.unavailability_dates_provider_id"
                        :validationRules="matriculeRequiredValidationRules"
                        :validationTranslation="$t('models.user.matricule')"
                        fieldName="unavailability_dates_provider_id"
                        fieldType="text"
                        fieldId="unavailability_dates_provider_id"
                        :label="providerIdLabel"
                        :required="matriculeRequired"
                        :disabled="false" />
          </div>


          <template v-if="!existingInAnotherEntity">
            <password-with-confirmation :password="user.password"
                                        :password-confirmation="user.password_confirmation"
                                        @input="user[$event.field] = $event.value" />
          </template>

          <div v-if="showEntityName" class="form-group form-group-default required">
            <label>{{ $t("UserForm.establishment") }}</label>
            <input :value="entityName" name="entity" readonly type="text" class="form-control text-black" required="">
          </div>

          <resource-type-field v-model="user.resource_type"
                               :disabled="false" />

          <occupations-field :available-occupations="occupationsOptions"
                             :is-manager="false"
                             :user="user"
                             @change="user.occupations = $event" />

          <services-with-hubs-filter :available-hubs="manageableHubsOptions"
                                     :availableServices="manageableServicesOptions"
                                     :disabledConditions="false"
                                     :dataUser="user"
                                     :isManager="false"
                                     :isInternal="isInternal"
                                     :small="true"
                                     :entity_id="entityId"
                                     :collapseHubs="true"
                                     @change="user[$event.field] = $event.value" />


          <div class="checkbox">
            <input v-model="user.acceptCGU" id="acceptCGU" name="acceptCGU" v-validate="'required'" type="checkbox"/>
            <label for="acceptCGU" v-html="$t('CandidateSignUpFormSidebar.accept_CGU', {url: externalLinks.termsOfService})">
            </label>
          </div>
          <transition name="slide-fade">
            <label v-show="errors.has('acceptCGU')" class="error" for="acceptCGU">{{ errors.first('acceptCGU')
              }}</label>
          </transition>
          <div class="row justify-content-end">
            <button
              type="submit"
              :disabled="submitDisabled"
              class="btn btn-primary btn-cons m-t-10">
              {{ $t("SignUpForm.register") }}
            </button>
          </div>
        </form>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { externalLinks } from "@/settings/externalLinks"
  import { formatNumber, parseNumber } from 'libphonenumber-js'
  import ie_mixin from '@/mixin/ie'
  import { checkValidEmail } from '@/helpers/email'
  import InputText from './form/InputText'
  import PasswordWithConfirmation from './form/PasswordWithConfirmation'
  import ResourceTypeField from '@/components/users/form/ResourceTypeField'
  import OccupationsField from '@/components/users/form/OccupationsField'
  import ServicesWithHubsFilter from '@/components/users/form/ServicesWithHubsFilter'
  import { unavailabilityDatesProviderIdLabel } from '@/helpers/entities'

  export default {
    name: "CandidateSignUpFormSidebar",
    mixins: [ie_mixin],
    props: ['entityId'],
    components: {
      InputText,
      PasswordWithConfirmation,
      ResourceTypeField,
      ServicesWithHubsFilter,
      OccupationsField,
    },
    computed: {
      ...mapGetters({
        user: 'users/user',
        currentUser: 'auth/currentUser',
        hasErrors: 'users/hasErrors',
        serverErrors: 'users/errors',
        manageableServicesOptions: 'users/manageableServices',
        manageableHubsOptions: 'users/manageableHubs',
        allServicesOptions: 'users/allServices',
        occupationsOptions: 'users/manageableOccupations',
        mailCheckedEmail: 'users/emailSuggestion'
      }),
      externalLinks () {
        return externalLinks
      },
      isInternal(){
        return this.user.resource_type == 'intern'
      },
      affiliatedServiceValidationRules(){
        return this.isInternal ? 'required' : ''
      },
      entityList() {
        if (this.currentUser) {
          return this.currentUser.entities
        }
      },
      currentEntity() {
        return this.entityList ? this.entityList.find(entity => entity.id == this.entityId) : null
      },
      entityName() {
        return this.currentEntity ? this.currentEntity.name : ''
      },
      showEntityName() {
        return this.entityList && this.entityList.length > 1
      },
      submitDisabled() {
        return this.userExistDifferentRole || this.existenceInEntity || (this.existingInAnotherEntity && this.user.pending)
      },
      existingInAnotherEntity() {
        return this.userExist && !this.existenceInEntity && !this.userExistDifferentRole
      },
      providerIdLabel() {
        return unavailabilityDatesProviderIdLabel(this.currentEntity)
      },
      showUnavailabilityDatesProviderId() {
        if (!this.currentEntity) return false;
        const providerScope = this.currentEntity.unavailabilities_provider_scope;
        return this.currentEntity && (providerScope=== 'entity' || providerScope === 'corporation');
      },
      matriculeRequired() {
        return this.showUnavailabilityDatesProviderId &&
              this.currentEntity.mark_unavailability_dates_provider_required === true;
      },
      matriculeRequiredValidationRules() {
        return this.matriculeRequired ? 'required' : '';
      }
    },
    data() {
      return {
        userExist: false,
        existenceInEntity: false,
        userExistDifferentRole: false,
      }
    },
    methods: {
      ...mapActions({
        resetUser: 'users/reset',
        initManageableOptions: 'users/initManageableOptions',
        removeErrors: 'users/removeErrors',
        verifyEmail: 'users/verifyEmail',
        resetMailSuggestion: 'users/resetMailSuggestion'
      }),
      submit() {
        this.$validator.validateAll().then((result) => {
          if(result){
            this.user.phone = formatNumber(parseNumber(this.user.phone_display, 'FR'), 'E.164')
            const userName = this.user.first_name + ' ' + this.user.last_name
            this.user.entity_id = this.entityId
            this.$store.dispatch('users/createPublicly', this.user).then(() => {
              if(!this.hasErrors){
                this.occupationsSelectedIE = [];
                this.servicesSelectedIE = [];
                this.$validator.reset();
                this.$store.dispatch('users/searchAllStates', this.entityId)
                this.$store.commit('users/SET_ACTIVE_TAB', 'confirmed')
                this.$store.dispatch('message/enable', { type: 'success', content: this.$t("messages.user_create_success", {'name' : userName}) })
                this.$refs.quickviewButton.click();
              }
            })
          }
        });
      },
      resetForm() {
        this.resetUser();
        this.occupationsSelectedIE = [];
        this.servicesSelectedIE = [];
        this.$validator.reset();
        this.removeErrors();
        $("label.fade").removeClass('fade');
      },
      resetUserInfo() {
        this.userExist = false
        this.existenceInEntity = false
        this.userExistDifferentRole = false
      },
      setEmail() {
        this.user.email = this.mailCheckedEmail
        this.resetMailSuggestion()
      }
    },
    watch: {
      occupationsSelectedIE: function (values) {
        var selected = []
        values.map(item => selected.push(this.searchInArray(item, this.occupationsOptions)))
        this.user.occupations = selected
      },
      servicesSelectedIE: function (values) {
        if(values.includes(this.$t("global.select_all"))) {
          values = [...this.manageableServicesOptionsIE]
          this.servicesSelectedIE = [...this.manageableServicesOptionsIE]
        }
        var selected = []
        values.map(item => selected.push(this.searchInArray(item, this.manageableServicesOptions)))
        this.user.services = selected
      },
      'user.email': function(value) {
        if (checkValidEmail(this.user.email)) {
          this.$store.dispatch('users/checkUserExistenceInEntity', { email: this.user.email, entity_id: this.entityId })
          .then((response) => {
            if (response) {
              this.userExistDifferentRole = response.role != "candidate"
              this.userExist = true
              this.existenceInEntity = response.existence
              this.user.pending = response.pending
              if (!this.userExistDifferentRole && !this.existenceInEntity && !(this.existingInAnotherEntity && this.user.pending)) {
                this.user.first_name = response.first_name
                this.user.last_name = response.last_name
                this.user.phone_display = formatNumber(parseNumber(response.phone, 'FR'), 'E.164')
              }
            } else {
              this.resetUserInfo()
            }
          })

          this.verifyEmail(this.user.email)
        } else {
          this.resetUserInfo()
        }
      },
      entityId: function() {
        this.initManageableOptions({ entityId: this.entityId });
      }
    },
    mounted: function () {
      this.resetUser();
      this.initManageableOptions({ entityId: this.entityId });
      window.Pages && window.Pages.initSelectFxPlugin(); // init Select dropdown handler
    }
  }
</script>

<style scoped lang="scss">
.form--suggestEmail {
  background-color: #F2F2F2;
  color: #6D7173;
  border-radius: 7px;
  padding: 7px;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.1rem;
  margin-bottom: 15px;
}
.email-suggestion {
  color: #e51349;
  cursor: pointer;
  text-decoration: underline;
}
  .quickview-toggle {
    font-size: 25px;
  }

  .quickview--signup {
    width: 496px;
    right: -496px;
    overflow: scroll;
  }

  .view-body {
    margin: 30px 20px 0;
    padding: 50px 50px 0;
  }

  .existence-notice {
    background: #e5f5f6;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    &.red {
      background: #fedad0;
      color: #e51349;
    }
  }

  @media (max-width: 768px) {
    .quickview--signup {
      width: 100%;
      right: -100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidateSignUpFormSidebar.vue